import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-3d4bd0b0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "properties-section",
    class: "properties-preview"
};
const _hoisted_2 = { class: "site-container" };
const _hoisted_3 = { class: "properties-preview__heading" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("span", { class: "section-kicker" }, "Propiedades seleccionadas"),
    /*#__PURE__*/ _createElementVNode("h2", null, [
        /*#__PURE__*/ _createTextVNode("Un lugar para tu"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createElementVNode("em", null, "próxima etapa.")
    ])
], -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "→", -1));
const _hoisted_6 = {
    key: 0,
    class: "properties-grid",
    "aria-label": "Cargando propiedades"
};
const _hoisted_7 = {
    key: 1,
    class: "properties-grid"
};
const _hoisted_8 = {
    key: 2,
    class: "properties-empty"
};
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Próximamente", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Estamos preparando nuevas oportunidades para compartir contigo.", -1));
const _hoisted_11 = [
    _hoisted_9,
    _hoisted_10
];
import { onMounted, ref } from 'vue';
import PropertyCard from './PropertyCard.vue';
import { apiRequest } from '@/services/api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PropertiesSection',
    setup(__props) {
        const properties = ref([]);
        const loading = ref(true);
        onMounted(async () => {
            try {
                properties.value = await apiRequest('/api/properties?limit=3');
            }
            catch (_) {
                properties.value = [];
            }
            finally {
                loading.value = false;
            }
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createVNode(_component_router_link, {
                            to: { name: 'properties' },
                            class: "view-all"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("Ver todas las propiedades "),
                                _hoisted_5
                            ]),
                            _: 1
                        })
                    ]),
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                                return _createElementVNode("div", {
                                    key: index,
                                    class: "property-skeleton"
                                });
                            }), 64))
                        ]))
                        : (properties.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(properties.value, (property) => {
                                    return (_openBlock(), _createBlock(PropertyCard, {
                                        key: property.id,
                                        property: property
                                    }, null, 8, ["property"]));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                ])
            ]));
        };
    }
});
